export const HEIGHT = 200;
export const WIDTH = 200;

export const FLOATING_DIALOG_TYPE_ARROW = 'arrow';
export const FLOATING_DIALOG_TYPE_CORNER = 'corner';
